import axios from 'axios'

const instance = axios.create({
  baseURL: `${process.env.VUE_APP_API_URL}/`,
  withCredentials: true,   // envía la cookie HttpOnly automáticamente
  headers: {
    'Content-Type':      'application/json',
    'X-Requested-With':  'XMLHttpRequest',
  },
});

// El token ya no se lee de sessionStorage para los requests HTTP normales.
// La cookie HttpOnly se envía automáticamente por el browser.
// Solo se mantiene en sessionStorage para el WebSocket (que no soporta cookies).
instance.interceptors.request.use(function (config) {
  return config;
});

export default instance;
